package com.veldekar.pages.log

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.PageContext
import com.veldekar.components.layouts.SessionPageLayout
import com.veldekar.components.logs.Log_2026_08_29_Day_1
import com.veldekar.components.logs.Log_2026_08_29_Day_2
import com.veldekar.components.logs.Log_2026_08_29_Day_3
import com.veldekar.components.logs.Log_2026_08_29_Day_4
import com.veldekar.components.widgets.SessionDayHeader
import com.veldekar.components.widgets.SessionMediaItem
import kotlinx.datetime.LocalDate

@Page(routeOverride = "/2026-08-29")
@Composable
public fun Log_2026_08_29(ctx: PageContext) {
    SessionPageLayout(
        ctx = ctx,
        title = "Setting the Record Straight",
        ogTitle = "Setting the Record Straight",
        date = LocalDate(2_026, 8, 29),
        aiHint = "Image shows Baghdad Bob (meme). Title and description are the opposite of the truth.",
        ogDescription = "A roc was never threatened by a Storm Giant or ominous clouds. The Friends of the Forest have not entered this territory. Unidentified Flying Bears? Truly, I can say there are, in fact, no UFBs anywhere.",
        ogImage = "images/aroc.webp",
        ogImageWidth = 1_200,
        ogImageHeight = 630,
    ) {
        SessionDayHeader(dayId = "shimmer-34", dateString = "Shimmer 34")
        Log_2026_08_29_Day_1()
        SessionDayHeader(dayId = "shimmer-35", dateString = "Shimmer 35")
        Log_2026_08_29_Day_2()
        SessionDayHeader(dayId = "shimmer-36", dateString = "Shimmer 36", cardImageSrc = "images/bearforce.webp", width = 1_200, height = 1_077)
        Log_2026_08_29_Day_3()
        SessionDayHeader(dayId = "shimmer-37", dateString = "Shimmer 37")
        Log_2026_08_29_Day_4()
        SessionMediaItem(
            image = "images/roc.webp",
            linkImage = "images/roc.webp",
            width = 1_200,
            height = 752,
        )
    }
}
